import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { loginInfoFormSuccess, LOGIN_INFO_FORM, loginInfoFormError } from "../actions/loginForm";
import { authentication } from "../../api/apiClient";
import { log } from "../../utils/loggger";
import { getAuthorizationHeader, getDeviceID } from "../selectors/appConfig";
import { setAccessToken } from "../actions/appConfig";
import { parseJwt } from "../../utils/genericUtils";

export function* loginFormSaga({ payload }) {
  try {
    const headers = yield select(getAuthorizationHeader);
    const DEVICE_ID = yield select(getDeviceID);
    const { deviceId: uniqueId = "" } = headers?.headers?.Authorization
      ? parseJwt(headers.headers.Authorization)
      : "";
    const response = yield call(
      authentication.login,
      { ...payload, deviceId: DEVICE_ID, uniqueId },
      headers
    );
    yield put(loginInfoFormSuccess(response.data));
    yield put(setAccessToken(response.data?.access_token));
  } catch (error) {
    log(error);
    yield put(loginInfoFormError(error));
  }
}

export default function* loginInfoFormSaga() {
  yield all([takeLatest(LOGIN_INFO_FORM, loginFormSaga)]);
}
